<template>
<div class="simulados">
  <div class="col-12 col-md-12">
  <b-tabs pills nav-class="abas-simulado d-flex align-items-center justify-content-center mb-4" content-class="" align="left">
  <b-tab title-item-class="mr-2" active v-if="quiz.idSimulado" >
    <template slot="title">
          <i class="fas fa-list"></i>
  Quiz
    </template>
    <div class="col-12 mt-4 mt-md-0" v-if="quiz.questoes" >
      <quiz :quiz="quiz" :curso="curso" />
    </div>
  </b-tab>
  <b-tab v-if="simulados.length > 0">
    <template slot="title">
      <i class="icon-sim mdi mdi-frequently-asked-questions" alt="Ícone para simulado"></i>
  {{ configEmpresa.textosConfiguraveis.textoDisplaySimulados }}
    </template>
          <h2 class="tit-sim">{{ configEmpresa.textosConfiguraveis.textoDisplaySimulados }} Disponíveis</h2>
    <div class="container meus-sim">
  <div class="table-responsive-xl">
    <table class="table">
      <tr>
        <th colspan="4"><i class="fas fa-list-ul"></i>{{nomeCurso}}</th>
      </tr>
        <tr v-for="simulado in simulados">
          <td width="20px">{{dataCadastro(simulado.created_at)}}</td>
          <td width="600px">{{ simulado.nomeSimulado }}</td>
          <td width="20px">{{ simulado.qtdQuestoes }} questões</td>
          <td class="text-right" width="20px">
            <div class="d-flex align-items-center justify-content-end">
              <a @click="selecionarSimulado(simulado)" class="btn btn-comecar" >Começar</a>
            </div>
          </td>
        </tr>
    </table>
  </div>
    </div>
    <span class="d-flex align-items-center justify-content-center">Não se esqueça de assistir todas as aulas antes de iniciar os {{ configEmpresa.textosConfiguraveis.textoDisplaySimulados }}! <i class="far fa-smile"></i></span>
  </b-tab>
  </b-tabs>
  </div>
</div>
</template>
<script>
import DateUtils from '@/core/utils/date-utils'
import { mapState } from 'vuex'
import SimuladoAPI from '@/api/simulado-api'
import ResponseUtils from '@/core/utils/response-utils'
import Quiz from '@/modules/SalaAula/components/ferramenta-estudo/items/Quiz'

export default {
  name: 'Simulados',
  components: { Quiz },
  props: {
    simulados: Array,
    quiz: null,
    curso: Object
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      nomeCurso: (state) => state.nomeCurso
    }),
    configEmpresa: function () {
      return this.$store.getters.empresa
    }
  },
  methods: {
    dataCadastro: function (date) {
      if (date !== null) {
        return DateUtils.formatDate(date, 'DD/MM/YYYY')
      }
      return 'Data não informada'
    },
    selecionarSimulado: function (simulado) {
      const idSimulado = simulado.idSimulado

      const loader = this.$loading.show()
      SimuladoAPI.criarSimuladoUsandoModelo(idSimulado).then(data => {
        window.open(`/simulados/prova/${data.simulado}`, '_blank')
        loader.hide()
      }).catch(error => ResponseUtils.handleError(error, loader))
    }
  }
}
</script>
